import React, { useState } from "react";
import img from "../../constant";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const FAQAccordion: React.FC = () => {
  const [openItems, setOpenItems] = useState<number[]>([1]); // First item open by default

  const toggleItem = (id: number) => {
    setOpenItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <div className="px-3 my-10 md:my-18">
      <div className="max-w-[940px] mx-auto">
        <div className="text-center mb-10">
          <p className="text-[18px] md:text-[35px] text-[#222222] mb-2">
            Common Inquiries
          </p>
          <p className="text-[14px] md:text-[16px] text-[#4E4E4E]">
            Everything you need to know about our AI-powered interview platform
            and advanced hiring features.
          </p>
        </div>
        {img.faqData.map((item) => (
          <div
            key={item.id}
            className="bg-white rounded-lg shadow-md border border-[#EFEFEF] overflow-hidden transition-all duration-200 hover:shadow-md mb-3"
          >
            <button
              onClick={() => toggleItem(item.id)}
              className="w-full px-6 py-3 text-left flex items-center justify-between bg-[#EFEFEF] hover:bg-gray-50 transition-colors duration-150"
              aria-expanded={openItems.includes(item.id)}
            >
              <span className="text-gray-800 text-sm md:text-[18px] pl-2 py-1 pr-4">
                {item.question}
              </span>
              <div className="flex-shrink-0">
                {openItems.includes(item.id) ? (
                  <FaChevronUp className="w-5 h-5 text-gray-500" />
                ) : (
                  <FaChevronDown className="w-5 h-5 text-gray-500" />
                )}
              </div>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                openItems.includes(item.id)
                  ? "max-h-96 opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <div className="px-6 pb-4 pt-1">
                <div className="text-sm md:text-[17px] text-gray-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQAccordion;
